import { render, staticRenderFns } from "./PoliciesContent.vue?vue&type=template&id=33b457e8&scoped=true"
var script = {}
import style0 from "./PoliciesContent.vue?vue&type=style&index=0&id=33b457e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b457e8",
  null
  
)

export default component.exports